var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsUUIDWithLVS, LengthWithLVS, TransformWithLVS } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { Allow, ArrayNotEmpty, IsArray, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { QueryBuilderStrategyEnum } from '../../cohort-query-builder';
import { CohortTemplateExposeGroup } from '../interface';
import { ReadCohortTemplateFeatureReferenceDto } from './ReadCohortTemplateFeatureReferenceDto';
let ReadCohortTemplateDto = class ReadCohortTemplateDto {
};
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4', example: 'e12acc6f-2f34-442c-92d3-d4199fb12345' }),
    IsUUIDWithLVS('4'),
    Expose({ groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ] }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCohortTemplateDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ, CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
    }),
    IsString({ groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    LengthWithLVS(3, 50, { groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], ReadCohortTemplateDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, maxLength: 255 }),
    Expose({
        groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ, CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
    }),
    IsOptional({ groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    IsString({ groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    MaxLength(255, { groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], ReadCohortTemplateDto.prototype, "description", void 0);
__decorate([
    ApiProperty({ type: () => ReadCohortTemplateFeatureReferenceDto, isArray: true }),
    Expose({
        groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ, CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
    }),
    Type(() => ReadCohortTemplateFeatureReferenceDto),
    ValidateNested({
        groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
        each: true,
    }),
    IsArray({ groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    ArrayNotEmpty({ groups: [CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE] }),
    __metadata("design:type", Array)
], ReadCohortTemplateDto.prototype, "features", void 0);
__decorate([
    ApiProperty({ type: () => String, format: 'date-time' }),
    Expose({ groups: [CohortTemplateExposeGroup.READ] }),
    TransformWithLVS(({ value }) => (value instanceof Date ? value.toISOString() : value), { groups: [CohortTemplateExposeGroup.READ], toPlainOnly: true }),
    __metadata("design:type", String)
], ReadCohortTemplateDto.prototype, "createdAt", void 0);
__decorate([
    ApiProperty({ type: () => String, format: 'date-time' }),
    Expose({ groups: [CohortTemplateExposeGroup.READ] }),
    TransformWithLVS(({ value }) => (value instanceof Date ? value.toISOString() : value), { groups: [CohortTemplateExposeGroup.READ], toPlainOnly: true }),
    __metadata("design:type", String)
], ReadCohortTemplateDto.prototype, "updatedAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ, CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadCohortTemplateDto.prototype, "strategy", void 0);
ReadCohortTemplateDto = __decorate([
    ApiExtraModels(ReadCohortTemplateFeatureReferenceDto)
], ReadCohortTemplateDto);
export { ReadCohortTemplateDto };
//# sourceMappingURL=ReadCohortTemplateDto.js.map